export default __webpack_public_path__ + "static/media/myprint.31d84cba.png";